import { Flex, Box } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { DropDown } from "ui/DropDown/DropDown";
import { DropDownOption } from "ui/DropDown/DropDownList";
import { BodyM, TitleM } from "ui/Typography/Typography";

export function BatteryRegistrationCard({
  serialNumber,
  brandOptions,
  selectedBrand,
  setSelectedBrand,
  modelOptions,
  selectedModel,
  setSelectedModel,
}: {
  serialNumber: string;
  brandOptions: DropDownOption[];
  selectedBrand: DropDownOption | null;
  setSelectedBrand?: (brandId: string) => void;
  modelOptions: DropDownOption[];
  selectedModel: DropDownOption | null;
  setSelectedModel?: (modelId: string) => void;
}) {
  const intl = useIntl();

  return (
    <Flex p="s200" direction="column" gap="s200" borderRadius="sm" bg="white">
      <BodyM noOfLines={1} wordBreak="break-all">
        <strong>
          {selectedModel?.label ||
            intl.formatMessage({ id: "pages.inventory.battery-management.battery" })}
        </strong>{" "}
        {serialNumber}
      </BodyM>
      <Box>
        <TitleM color="grey.800" mb="s25">
          {intl.formatMessage({ id: "pages.inventory.battery-details-page.brand" })}
        </TitleM>
        <DropDown
          options={brandOptions}
          disabled={brandOptions.length === 1}
          value={selectedBrand?.key || ""}
          onInput={(brand) => {
            setSelectedBrand?.(brand as string);
          }}
          filterMode={false}
          border="1px solid"
          borderColor="grey.800"
          borderRadius="8px"
          bgColor="white"
          titleColor="grey.800"
          w="100%"
          h="40px"
          listStyles={{ w: "300px", maxH: "300px" }}
          listItemStyles={{ w: "300px" }}
          placement="auto"
        >
          <BodyM color="grey.800">
            {intl.formatMessage({
              id: "pages.inventory.battery-details-page.brand-placeholder",
            })}
          </BodyM>
        </DropDown>
      </Box>
      <Box>
        <TitleM color="grey.800" mb="s25">
          {intl.formatMessage({ id: "pages.inventory.battery-details-page.model" })}
        </TitleM>
        <DropDown
          options={modelOptions}
          value={selectedModel?.key || ""}
          onInput={(newModel) => {
            setSelectedModel?.(newModel as string);
          }}
          disabled={modelOptions.length === 1}
          filterMode={false}
          border="1px solid"
          borderColor="grey.800"
          borderRadius="8px"
          bgColor="white"
          titleColor="grey.800"
          w="100%"
          h="40px"
          listStyles={{ w: "300px", maxH: "300px" }}
          listItemStyles={{ w: "300px" }}
          placement="auto"
        >
          <BodyM color="grey.800">
            {intl.formatMessage({
              id: "pages.inventory.battery-details-page.model-placeholder",
            })}
          </BodyM>
        </DropDown>
      </Box>
    </Flex>
  );
}
